// extracted by mini-css-extract-plugin
module.exports = {"createList":"CreateList-module__createList___1A2Wv","title":"CreateList-module__title___1yc6C","predefinedImages":"CreateList-module__predefinedImages___cPraL"};